import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { map } from 'rxjs/operators';
import { ExternalMember } from '../../models/member/external-member.model';
import { InternalMember } from '../../models/member/internal-member.model';
import { ExchangeApiService } from '../exchange-api.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalMemberRepository {

  private readonly baseUrl = 'external_members';

  constructor(
    private exchangeApiService: ExchangeApiService,
  ) {
  }

  get(id: string): Observable<InternalMember> {
    return this.exchangeApiService
      .get(`${this.baseUrl}/${id}`)
      .pipe(
        map(response => new ExternalMember(response)),
      );
  }

  create(member: ExternalMember): Observable<ExternalMember> {
    return this.exchangeApiService
      .post(this.baseUrl, member)
      .pipe(
        map(data => new ExternalMember(data)),
      );
  }

  edit(member: ExternalMember): Observable<ExternalMember> {
    return this.exchangeApiService
      .put(`${this.baseUrl}/${member.id}`, member)
      .pipe(
        map(data => new ExternalMember(data)),
      );
  }

  delete(id: string): Observable<ExternalMember> {
    return this.exchangeApiService.delete(`${this.baseUrl}/${id}`);
  }
}
